import Axios from "axios";
import ToastMessage from '../../components/toast';
import { GET_WAGE_PARITY_REPORT, LATE_PAYROLL, ALL_USERS, SET_ERROR, ALL_COMPANIES } from "../types";

export const getSyncWageParity = () => async (dispatch) => {
    await Axios.get(`api/sync-report/sync-wage-parity`).then((response) => {
        dispatch({
            type: GET_WAGE_PARITY_REPORT,
            payload: response.data.data,
        });
    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: {
                e,
                error: true
            }
        })
    });

};
export const getSyncLatePayroll = () => async (dispatch) => {

    await Axios.get(`api/sync-report/sync-late-payrolls`).then((response) => {
        dispatch({
            type: LATE_PAYROLL,
            payload: response.data.data,
        });
    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: {
                e,
                error: true
            }
        })
    });

};
export const getSyncClient = () => async (dispatch) => {
    await Axios.get(`api/sync-report/sync-clients`).then((response) => {
        dispatch({
            type: ALL_COMPANIES,
            payload: response.data
        });
    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: {
                e,
                error: true
            }
        });
    });
};

export const getSyncUser = () => async (dispatch) => {
    await Axios.get(`api/sync-report/sync-users`).then((response) => {
        dispatch({
            type: ALL_USERS,
            payload: response.data
        });
    }).catch(e => {
        dispatch({
            type: SET_ERROR,
            payload: {
                e,
                error: true
            }
        });
    });
};

async function syncPayrollAction(company) {
    Axios.get(`api/payroll/sync-payroll/${company}`).then(res => {
        ToastMessage("Payroll successfully updated", "success")
        return res;
    }).catch(e => {
        ToastMessage(e.message, "error");
    });
};
async function getSyncCostCenter(compId) {
    Axios.get(`api/cost-centers/get-sync-cost-center/${compId}`).then(res => {
        ToastMessage("Cost Centers successfully updated", "success");
        return res;
    }).catch(e => {
        ToastMessage(e.response?.data, "error")
    });
};
async function getSyncEarningsCodes(companyShortName, company) {
    Axios.get(`api/earning-codes/sync-earning-code-by-company`, { params: { companyShortName, company } }).then(res => {
        ToastMessage("Earning Codes successfully updated", "success");
        return res;
    }).catch(e => {
        ToastMessage(e.message, "error");
    });
};

async function getSyncEins(companyShortName, compId) {
    Axios.get(`api/sync-report/sync-company-eins/`, { params: { companyShortName, company: compId } }).then(res => {
        ToastMessage("EINs successfully updated", "success");
        return res;
    }).catch(e => {
        ToastMessage(e.message, "error");
    });
};

async function syncDeductionSchedules(companyShortName, _id) {
    Axios.get('api/deductions/sync-settings', {
        params: { companyShortName, _id }
    }).then(res => {
        ToastMessage("Deduction Settings successfully updated", "success");
        return res;
    }).catch(e => {
        ToastMessage(e.message, "error");
    });
};

async function syncCostCenterJobs(companyShortName, companyId, isHR) {
    if (isHR) {
        Axios.get('api/sync-report/sync-cc-jobs', {
            params: { companyShortName, companyId }
        }).then(res => {
            ToastMessage("Cost Center Jobs successfully updated", "success");
            return res;
        }).catch(e => {
            ToastMessage(e.message, "error");
        })
    }
}

export const syncCompanyData = (company, compId, isHR) => async () => {
    let response = await Promise.allSettled([
        getSyncEarningsCodes(company, compId),
        getSyncCostCenter(compId),
        syncPayrollAction(company),
        getSyncEins(company, compId),
        syncDeductionSchedules(company, compId),
        syncCostCenterJobs(company, compId, isHR)
    ]);
    return response;
};

export const runCrons = (cronJobName) => async () => {
    await Axios.get(`api/listing/run-sync/${cronJobName}`).then((response) => {
        ToastMessage(`${cronJobName} done`, "success");
        return response;
    }).catch(e => {
        ToastMessage(e.message, "error")
    });
};